module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/3e3e5f8a22c80c09294ebfc9559ceeac.png";